module.exports = __webpack_public_path__ + "assets/team.175fe309.jpg";


//////////////////
// WEBPACK FOOTER
// ../source/assets/team.jpg
// module id = 1606
// module chunks = 0